import {
  destroyAdmin,
  getAdmin,
  patchAdmin,
  postAdmin,
  putAdmin,
} from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";

export const complaints = {
  add: {
    key: "add",
    call: (payload) => {
      return postAdmin(`/admin/complaints/`, payload);
    },
  },
  property: {
    key: "property",
    call: (companyId, page, search) => {
      const query = buildQueryString({
        company_id: companyId,
        page,
        search,
        page_size: 100,
      });
      return getAdmin(`/admin/property_dropdown_by_company/?${query}`);
    },
  },
  list: {
    key: "list",
    call: (
      page,
      search,
      property_name,
      date_start,
      date_end,
      status,
      priority,
      pending,
      ordering,
    ) => {
      const query = buildQueryString({
        page,
        search,
        priority,
        property_id: property_name,
        created_at_from: date_start,
        created_at_to: date_end,
        status,
        pending,
        ordering,
      });
      return getAdmin(`/admin/complaints/?${query}`);
    },
  },
  details: {
    key: "details",
    call: (id) => {
      return getAdmin(`/admin/complaints/${id}/`);
    },
  },
  log: {
    key: "log",
    call: (page, id) => {
      const query = buildQueryString({ page });
      return getAdmin(`/admin/complaint-logs/${id}/?${query}`);
    },
  },
  delete: {
    key: "delete",
    call: (id, permanent = false) => {
      const query = permanent ? "?permanent=true" : "";
      return destroyAdmin(`/admin/complaints/${id}/${query}`);
    },
  },
  update: {
    key: "update",
    call: (Id, payload) => {
      return putAdmin(`/admin/complaints/${Id}/`, payload);
    },
  },
  updatestatus: {
    key: "updatestatus",
    call: (id, payload) => {
      return postAdmin(`/admin/complaint-update/${id}/`, payload);
    },
  },
  staff: {
    key: "staff",
    call: (page, search, propertyId) => {
      const query = buildQueryString({
        page,
        search,
        property_id: propertyId,
        page_size: 100,
      });
      return getAdmin(`/admin/captured_by_user_dropdown/?${query}`);
    },
  },
  report: {
    key: "report",
    call: (search, property_name, date_start, date_end, status, priority) => {
      const query = buildQueryString({
        search,
        priority,
        property: property_name,
        created_at_from: date_start,
        created_at_to: date_end,
        status,
      });
      return getAdmin(`/admin/complaint_report/?${query}`);
    },
  },
};
